module.exports = __webpack_public_path__ + "img/video.07e4486f.png";